module.exports = __webpack_public_path__ + "img/TabbotSecurityLogo.49abd78f.svg";